<template>
  <div class="padding7 el-card">
    <el-form label-width="120px" label-position="left">
      <div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-table
              :data="cloudTableData"
              border
              size="mini"
              ref="cloudTableData"
            >
              <el-table-column label="操作" width="80px">
                <template slot-scope="scope">
                  <el-tooltip content="检测" placement="top">
                    <el-button
                      type="info"
                      icon="el-icon-bell"
                      circle
                      @click="checkStatus(scope.row)"
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="品牌名"></el-table-column>
              <el-table-column
                prop="brandCode"
                label="品牌编号"
              ></el-table-column>
              <el-table-column
                label="所属模块"
                prop="moduleConfName"
              ></el-table-column>
              <el-table-column label="配置参数">
                <template slot-scope="scope">{{ scope.row.params }}</template>
              </el-table-column>
            </el-table>
            <pagerBar
              ref="refPagerBar"
              :apiURL="CloudBrandListApiUrl"
              :GetData="getTableData"
              :queryParam="queryParam"
              :errorFunc="closeloading"
            ></pagerBar>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";

export default {
  data() {
    return {
      queryParam: { Filter: this.tabType }, //分页查询参数
      CloudBrandListApiUrl: config.BASE_Middle_API + "apiCheck/GetAllBrand",
      CheckStatusApiUrl:
        config.BASE_Middle_API + "apiCheck/CheckSourceApiStatus",
      cloudTableData: [],
    };
  },
  components: {
    pagerBar,
  },
  props: {
    openloading: {
      type: Function,
      required: true,
    },
    closeloading: {
      type: Function,
      required: true,
    },
    tabType: {
      type: String,
      required: true,
    },
  },

  methods: {
    checkStatus(item) {
      const _this = this;
      _this.openloading();
      const confirmData = {
        brandId: item.brandId,
        tabType: _this.tabType,
      };
      AjaxHelper.post(_this.CheckStatusApiUrl, confirmData).then(function (
        response
      ) {
        if (response.result) {
          _this.$notify({
            title: "提示",
            message: "API接口状态正常",
            type: "success",
            position: "bottom-right",
          });
        } else {
          _this.$notify({
            title: "提示",
            message: "API接口连接失败，请检查相关参数",
            type: "error",
            position: "bottom-right",
          });
        }
        _this.closeloading();
      });
    },
    getTableData(data) {
      this.cloudTableData = data;
      this.closeloading();
    },
  },
};
</script>

<style scoped>
.minicard {
  height: auto !important;
  display: block;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 9989;
  top: 80px;
}
.minicard .el-button {
  width: 150px;
  margin: 5px 0;
}
.el-dialog__body {
  padding: 10px 15px !important;
}

dl.loglist p {
  font-weight: 600;
  margin: 20px 0 10px 0;
}
dl.loglist dd {
  padding: 15px 0;
  color: #999999;
  display: block;
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.w25 {
  width: 25%;
  float: left;
}
.w75 {
  width: 75%;
  float: left;
}
.el-card {
  border: 0;
  height: calc(100vh - 225px);
  overflow-y: auto;
}
.padding7 {
  padding: 7px;
}
.top5 {
  padding: 5px 0 0 0;
}
.top7 {
  padding: 7px 0 0 0;
}
</style>
